<template>
	<div>
		<userMenu></userMenu>
		<div class="cclist-wrap">
			<div class="cc-head">
				<el-tag type="success" effect="plain">提示词管理</el-tag>
				<el-input v-model="input" placeholder="输入关键字搜索" size="small" style="width: 200px;margin-left: 40px;margin-right:5px;"></el-input>
				<el-button type="primary" size="small" icon="el-icon-search">搜索</el-button>
			</div>
			<div class="cclist-box">
				<div class="cclist-wd">
					<el-table :data="listData" style="width: 100%">
						<el-table-column prop="id" label="ID" width="70">
						</el-table-column>
						<el-table-column label="标题">
							<template slot-scope="scope">
								<a :href="'http://www.beiyv.com/detail.php?id='+scope.row.id" target="_blank" style="color: #000;">{{scope.row.title}}</a>
							</template>
						</el-table-column>
						<el-table-column prop="cate_id" label="栏目" width="70">
						</el-table-column>
						<el-table-column label="状态" width="80">
							<template slot-scope="scope">
								<el-tag size="small" type="danger" v-if="scope.row.audit==0">待审核</el-tag>
								<el-tag size="small" type="success" v-if="scope.row.audit==1">已上线</el-tag>
								<el-tag size="small" type="warning" v-if="scope.row.audit==2">未通过</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="cover_img" label="图片" width="170">
						</el-table-column>
						<el-table-column prop="user_id" label="用户" width="70">
						</el-table-column>
						<el-table-column prop="views" label="浏览量" width="70">
						</el-table-column>
						<el-table-column prop="create_time" label="时间" width="170">
						</el-table-column>
						<el-table-column fixed="right" label="操作" width="240">
							<template slot-scope="scope">
								<!-- <el-popconfirm title="这是一段内容确定删除吗？">
									<el-tag type="warning" effect="dark" size="mini" slot="reference">审核3</el-tag>
								</el-popconfirm> -->
								<el-button type="primary" size="mini" effect="dark" @click="editItem(scope.row)">编辑</el-button>
								<el-button type="warning" effect="dark" size="mini" @click="auditWord(scope.row)" v-if="scope.row.audit==0">审核</el-button>
								<el-button type="info" effect="dark" size="mini" @click="auditWord0(scope.row)" v-else>下架</el-button>
								<el-button type="danger" size="mini" effect="dark">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="cclist-paeg" v-if="total>0">
				<el-pagination @current-change="nextPage" background :current-page="page" :page-size="rows" layout="total,prev, pager, next"
				 :total="total"></el-pagination>
			</div>
		</div>

		<el-dialog title="编辑提示词" :visible.sync="editPup" width="500px">
			<div class="pup-wd">
				<el-input placeholder="请输入内容" v-model="theTitle" size="small">
					<template slot="prepend">标题</template>
				</el-input>
				<el-cascader style="width: 100%;" size="small" placeholder="请选择栏目" v-model="theCid" :options="catData" :props="{ expandTrigger: 'hover' }"></el-cascader>
				<el-input placeholder="请输入内容" v-model="thePic" size="small">
					<template slot="prepend">图片</template>
				</el-input>
				<el-input placeholder="请输入内容" v-model="theChang" size="small">
					<template slot="prepend">场景</template>
				</el-input>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="editPup = false" size="small">取 消</el-button>
				<el-button type="primary" @click="setInfo" size="small">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import userMenu from '@/page/public/userMenu'
	import api from '@/api/api'
	export default {
		components: {
			userMenu: userMenu
		},
		data() {
			return {
				page: 1,
				rows: 13,
				total: 0,
				listData: [],
				editPup: false,
				theTitle:'',
				theCid:'',
				thePic:'',
				theId:'',
				theChang:'',
				catData:[],
			}
		},
		methods: {
			setInfo(){
				let params = {
					token: api.getCookie('token'),
					title:this.theTitle,
					pic:this.thePic,
					cid:this.theCid,
					id:this.theId,
					tags:this.theChang
				}
				api.setWordInfo(params).then(res=>{
					if(res.code==200){
						this.$message.success(res.msg);
						this.getWordList();
						this.editPup = false;
					}else{
						this.$message.error(res.msg);
					}
				})
			},
			editItem(data) {
				this.theTitle = data.title;
				this.theCid = [data.pid,data.cate_id];
				this.thePic = data.cover_img;
				this.theId = data.id;
				this.theChang = data.tags;
				this.editPup = true;
			},
			auditWord(data) {
				let params = {
					token: api.getCookie('token'),
					id: data.id,
					status: 1
				}
				api.setAudit(params).then(res => {
					if (res.code == 200) {
						this.$message.success('已上线');
						this.getWordList();
					} else {
						this.$message.error(res.msg);
					}
				})
				return
				this.$confirm('是否上线网站？', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					let params = {
						token: api.getCookie('token'),
						id: data.id,
						status: 1
					}
					api.setAudit(params).then(res => {
						if (res.code == 200) {
							this.$message.success('已下架');
							this.getWordList();
						} else {
							this.$message.error(res.msg);
						}
					})
				}).catch(() => {

				});
			},
			auditWord0(data) {
				let params = {
					token: api.getCookie('token'),
					id: data.id,
					status: 0
				}
				api.setAudit(params).then(res => {
					if (res.code == 200) {
						this.$message.success('已下架');
						this.getWordList();
					} else {
						this.$message.error(res.msg);
					}
				})
			},
			nextPage(val) {
				this.page = val;
				this.getWordList();
			},
			getCatName(pid) {
				let data = this.catData;
				for (let i in data) {
					if (data[i].value == pid) {
						return data[i].label;
					}
				}
			},
			getCatName2(pid, cid) {
				let data = this.catData;
				for (let i in data) {
					if (data[i].value == pid) {
						for (let j in data[i].children) {
							if (data[i].children[j].value == cid) {
								return data[i].children[j].label;
							}
						}
					}
				}
			},
			getWordList() {
				let params = {
					token: api.getCookie('token'),
					page: this.page,
					rows: this.rows
				}
				api.getListByAll(params).then(res => {
					if (res.code == 200) {
						this.listData = res.data.list;
						this.total = parseInt(res.data.total);
					}
				})
			},
			getCategoryList() {
				api.getCategoryList({}).then(res => {
					let data = res.data;
					let arry = [];
					for (let i in data) {
						let obj = {
							value: data[i].id,
							label: data[i].name,
							children: []
						}
						for (let j in data[i].children) {
							let obj2 = {
								value: data[i].children[j].id,
								label: data[i].children[j].name,
							}
							obj.children.push(obj2)
						}
						arry.push(obj)
					}
					this.catData = arry;
				})
			}
		},
		created() {
			this.getCategoryList();
			this.getWordList()
		}
	}
</script>

<style>
	.pup-wd .el-input{
		margin-bottom: 10px;
	}
	.cclist-wd {
		padding: 20px 30px;
		background-color: #fff;
		border-radius: 10px;
	}

	.cclist-index {
		display: flex;
	}

	.cclist-paeg {
		text-align: center;
	}

	.cclist-btn {
		position: absolute;
		right: 0;
		top: 30px;
	}

	.cclist-bom {
		font-size: 12px;
		padding-left: 0;
		padding-top: 5px;
		color: #666;
	}

	.cclist-tit span {
		position: relative;
		top: -2px;
	}

	.cclist-tit a {
		color: #000;
	}

	.cclist-tit a:hover {
		color: #0f5bff;
	}

	.cclist-tit {
		font-weight: bold;
	}

	.cclist-no {
		position: relative;
		top: -1px;
		font-size: 19px;
		font-family: 'numfont';
		width: auto;
		padding-right: 10px;
		color: #ddd;
	}

	.cclist-box ul {
		margin: 0;
		padding: 20px 40px;
		background-color: #fff;
		border-radius: 10px;
	}

	.cclist-box ul li {
		position: relative;
		margin: 0;
		padding: 20px 0;
		border-bottom: 1px solid var(--bg3);
	}

	.cclist-box {
		border-radius: 10px;
		margin: 0 20px;
		padding: 20px 0;
	}

	.cclist-wrap {
		width: 100%;
		min-height: 100vh;
		background-color: var(--bg3);
		box-sizing: border-box;
		padding-left: 220px;
	}
</style>



// WEBPACK FOOTER //
// src/page/cclist.vue